import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { WhatsAppConnection } from "@/components/screens/Platforms/WhatsappConnection";
import {
  WHATSAPP_CONNECTION_MESSAGES,
  WhatsAppConnectionMessages,
} from "@/messages/platforms/whatsappConnection/whatsapp-connection.messages";
import translationService from "@/services/translation.service";
import { Language } from "@/types/language.types";

const WhatsAppPage: React.FC = () => {
  const { lang = "PT-BR" } = useParams<{ lang?: string }>();
  const [messages, setMessages] = useState<WhatsAppConnectionMessages | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const translations = await translationService.get<WhatsAppConnectionMessages>(
          WHATSAPP_CONNECTION_MESSAGES,
          (lang as Language) ?? null
        );
        setMessages(translations);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return null; // Loading handled by Suspense in child components
  }

  if (!messages) {
    return <div>Erro ao carregar mensagens</div>;
  }

  return <WhatsAppConnection messages={messages} />;
};

export default WhatsAppPage;
